<template>
  <!-- gk-check-box{*} -->
  <div class='box-content' @click="onClick">
    <div class="box-back">
      <div class='box-block' v-if="isChoosed"></div>
    </div>
    {{changeChecked}}
  </div>
</template>

<script>
  export default {
    props: ['item'],
    data () {
      return {
        isChecked: false
      }
    },
    created () {
    },
    updated () {
    },
    computed: {
      changeChecked () {
        if (this.item.length === 2) this.isChecked = this.item[1].isR
      },
      isChoosed () {
        if (this.item.length === 1) {
          let item = this.item[0]
          let choosedItems = this.$store.state.Counter.choosedItems
          let isExist = false
          for (let index in choosedItems) {
            if (item._id === choosedItems[index]._id) {
              isExist = true
              break
            }
          }
          return isExist
        } else {
          return this.isChecked
        }
      }
    },
    methods: {
      onClick () {
        this.isChecked = !this.isChecked
        if (this.item.length === 2) this.item[1].isR = this.isChecked
        this.$store.commit('CLICK_LIST_ITEM', this.item)
      }
    }
  }
</script>
<style scoped>

  .box-content {
    height: 100%;
    width: 100%;
    border: medium solid rgb(71, 71, 71);
    padding: 4px;
  }

  .box-back {
    height: 100%;
    width: 100%;
  }

  .box-block {
    height: 100%;
    width: 100%;
    background: rgb(12, 153, 12);
  }
  
  
</style>


// WEBPACK FOOTER //
// src/components/CheckBox.vue